"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _moment = _interopRequireDefault(require("moment"));
var _hike = require("@/api/hike");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "HikeParticipant",
  props: {
    parentId: {
      type: String,
      default: ""
    },
    internalTitle: {
      type: String,
      default: ""
    },
    parentStaff: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      participantList: [],
      unEnrollParticipantVisible1: false,
      unEnrollParticipantVisible2: false,
      unEnrollParticipantName: "",
      unEnrollParticipantUuid: "",
      staff: [],
      haveLoop: false
    };
  },
  watch: {
    parentStaff: {
      handler(newVal) {
        console.info("parentStaff newVal:");
        console.info(newVal);
        this.staff = newVal;
        console.info(this.staff);
      },
      deep: true
    }
  },
  created() {
    var id = this.parentId;
    this.staff = this.parentStaff;
    if (id !== "copy") {
      this.getHikeParticipants();
      this.gethikeRelatedLoops(id);
    }
  },
  methods: {
    getHikeParticipants() {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var id = this.parentId;
      (0, _hike.getParticipant)(token, id).then(response => {
        this.loading = false;
        const dataList = response.data.rows.map(p => {
          if (p.enrolledBy) {
            p.enrolledByVal = p.enrolledBy.uuid;
          } else {
            p.enrolledByVal = null;
          }
          return p;
        });
        console.info(dataList);
        this.participantList = dataList;
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)("Hike-getParticipant-API-error", error);
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    unEnrollParticipant(user) {
      this.unEnrollParticipantVisible2 = false;
      this.unEnrollParticipantVisible1 = true;
      this.unEnrollParticipantName = user.givenName + " " + user.familyName;
      this.unEnrollParticipantUuid = user.uuid;
    },
    unEnrollParticipantFirstConfirm() {
      this.unEnrollParticipantVisible1 = false;
      setTimeout(() => this.unEnrollParticipantVisible2 = true, 500);
    },
    doUnEnrollParticipant() {
      // Reset
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.loading = true;
      (0, _hike.unenrollParticipant)(token, this.parentId, this.unEnrollParticipantUuid).then(response => {
        this.getHikeParticipants();
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)("Hike-getParticipant-API-error", error);
        (0, _log.displayPopupMessage)(error, "error", null, false);
      });
      this.unEnrollParticipantVisible1 = false;
      this.unEnrollParticipantVisible2 = false;
      this.unEnrollParticipantName = "";
      this.unEnrollParticipantUuid = "";
    },
    sort_change(column) {
      let newItems = this.participantList.sort(this.sortFun(column.prop));
      if (column.order === "descending") {
        newItems = newItems.reverse();
      }
      this.participantList = newItems;
      //console.info("sort a:"+JSON.stringify(this.participantList));
    },
    sortFun(attr) {
      return function (item1, item2) {
        item1 = item1[attr].toLowerCase();
        item2 = item2[attr].toLowerCase();
        if (item1 < item2) {
          return -1;
        } else if (item1 > item2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    UpdateHikeParticipantEnrolledBy(user) {
      const data = {
        enrolledBy: user.enrolledByVal ? user.enrolledByVal : 'N/A'
      };
      const uuid = user.uuid;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.loading = true;
      (0, _hike.updateHikeParticipantEnrolledBy)(token, uuid, this.parentId, data).then(response => {
        const msg = 'The participant’s enrolled by is updated successfully.';
        (0, _log.displayPopupMessage)(msg, "success");
        this.getHikeParticipants();
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)("Hike-getParticipant-API-error", error);
        (0, _log.displayPopupMessage)(error, "error", null, false);
      });
    },
    gethikeRelatedLoops(id) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.loading = true;
      (0, _hike.hikeRelatedLoops)(token, id).then(response => {
        const d = response.data;
        this.haveLoop = d.count > 0 ? true : false;
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)("hike-hikeRelatedLoops-error", error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    }
  }
};